<template>
  <v-list-item v-if="href" link :href="link">
    <v-list-item-icon>
      <v-icon class="white--text">{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-title class="white--text">{{ label }} </v-list-item-title>
  </v-list-item>
  <v-list-item v-else link :to="link">
    <v-list-item-icon>
      <v-icon class="white--text">{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-title class="white--text">{{ label }} </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: "MyItemsMenu",
  props: {
    link: String,
    href: {
      type: Boolean,
      default: false,
    },
    icon: String,
    label: String,
  },
};
</script>

<style scoped></style>
